import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LayerToggle from '../../../views/map/LayerToggle';
import TollsForm from './TollsForm';
import utils from 'utils';
import { get } from 'lodash';

class TollsContainer extends Component {
  constructor(...args) {
    super(...args);
    this.state = { formExpanded: false };
  }

  stopPropagation = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.formExpanded && !prevState.formExpanded) {
      const isTollsActive = get(this.props, 'result.state.isTollsActive');
      if (!isTollsActive) this.onTollsToggle();
    }
  }

  onToggleMenu = () => {
    const { formExpanded } = this.state;
    if (formExpanded) {
      this.setState({ formExpanded: false });
      window.removeEventListener('click', this.onToggleMenu);
    } else {
      this.setState({ formExpanded: true });
      window.addEventListener('click', this.onToggleMenu);
    }
  };

  onTollsToggle = () => {
    const { 
      setResultState, setNotification, setFields, fields, request, 
    } = this.props;
    const isTollsActive = get(this.props, 'result.state.isTollsActive');

    let returnValues = get(fields, 'return.values', []);
    let spanValues = get(fields, 'spans.values', []);
    let missingParams = [];
    if (!isTollsActive) {
      const showTollbooth = get(this.props, 'result.state.showTollbooth', true);
      const showTollroad = get(this.props, 'result.state.showTollroad', true);

      if (showTollbooth && !returnValues.includes('tolls')) {
        setFields({ return: { values: [...returnValues, 'tolls'] } });
        missingParams.push('tolls into return');
      }
      if (showTollroad && !spanValues.includes('tollSystems')) {
        setFields({ spans: { values: [...spanValues, 'tollSystems'] } });
        missingParams.push('tollSystems into spans');
      }

      if (missingParams.length) {
        request();
        setNotification({
          message: `Add ${missingParams.join(', ')} and request.`,
          impact: 'significant',
          autoDismiss: 5,
        });
      }
    }
    
    setResultState({ isTollsActive: !isTollsActive });
  };

  onCheckboxChange = (prop, event) => {
    this.props.setResultState({ [prop]: utils.extractData(event) });
  };

  onTollSystemsCheckboxChange = (prop, name, event) => {
    let tollSystems = get(this.props, ['result', 'state', prop], '');
    if (utils.extractData(event)) {
      tollSystems = tollSystems.split(',')
      .filter(item => item !== name)
      .join(',');
    } else {
      if (tollSystems === '')
        tollSystems = name;
      else 
        tollSystems = tollSystems + ',' + name;
    }

    this.props.setResultState({ [prop]: tollSystems });
  };

  updateFilterValue(key, value) {
    const { setFields } = this.props;
    setFields({ [key]: value });
  }

  renderTollsForm(isTollsActive) {
    const { colorPalette,  result } = this.props;

    const currentRoute = get(result, 'state.currentRoute') || 0;
    const showTollbooth = get(result, 'state.showTollbooth', true);
    const showTollroad = get(result, 'state.showTollroad', true);
    const showTollboothName = get(result, 'state.showTollboothName', true);
    const tollSystemsRoadExclude = get(result, 'state.tollSystemsRoadExclude', '');
    const route = get(result, ['raw','data','routes', currentRoute], {sections: []});

    return (
      <TollsForm
        rangeOnRoute={result.state}
        colorPalette={colorPalette}
        route={route}
        isActive={isTollsActive}
        showTollbooth={!!showTollbooth}
        showTollroad={!!showTollroad}
        showTollboothName={!!showTollboothName}
        tollSystemsRoadExclude={tollSystemsRoadExclude}
        onCheckboxChange={this.onCheckboxChange}
        onTollSystemsCheckboxChange={this.onTollSystemsCheckboxChange}
        onToggle={this.onTollsToggle}
        onBlur={this.onToggleMenu}
      />
    );
  }

  render() {
    const { selectedTab, tabIndex, result } = this.props;

    if ( selectedTab !== tabIndex ) {
      return <></>;
    }
    const tooltipText = this.state.formExpanded ? undefined : 'Tolls Road';
    const isTollsActive = get(result, 'state.isTollsActive');

    return (
      <div onClick={this.stopPropagation}>
        <div className="rf-map__tolls-toggle">
          <LayerToggle
            active={!!isTollsActive}
            disabled={false}
            onChange={this.onToggleMenu}
            tooltipText={tooltipText}
          />
        </div>
        {this.state.formExpanded && this.renderTollsForm(!!isTollsActive)}
      </div>
    );
  }
}

TollsContainer.propTypes = {
  fields: PropTypes.object.isRequired,
  result: PropTypes.object.isRequired,
  request: PropTypes.func.isRequired,
  setResultState: PropTypes.func.isRequired,
  setFields: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
  tabIndex: PropTypes.number.isRequired,
};

export default TollsContainer;
